import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {isPlaneteer} from '@apps-common/auth-utils';
import {useAuth} from '@apps-common/auth-react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import ContactSalesButton from '@explorer/components/ui/contact-sales-button';
import {showNoQuotaBanner} from '@explorer/selectors/tile-groups';

const NoQuotaBanner = () => {
  const {t} = useTranslation();
  const auth = useAuth();
  const doShow = useSelector(state => showNoQuotaBanner(state));
  const loadingSubscriptions = useSelector(
    state => state.subscriptions.loading
  );

  if (isPlaneteer(auth.user.claims.email) || loadingSubscriptions || !doShow) {
    return false;
  }

  return (
    <AppBar
      position="static"
      color="primary"
      elevation={0}
      sx={{
        '.MuiToolbar-root': {
          px: 1,
        },
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          bgcolor: 'grey.700',
          color: 'common.white',
          justifyContent: 'center',
        }}
      >
        <Grid container alignItems="center">
          <Grid item xs>
            &nbsp;
          </Grid>
          <Grid item xs="auto">
            <Typography variant="body2" align="center">
              {t('noQuotaBanner.messageTiles')}
            </Typography>
          </Grid>
          <Grid
            item
            xs
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <ContactSalesButton
              variant="outlined"
              sx={{
                ml: 2,
                borderColor: 'primary.main',
                lineHeight: theme => theme.typography.body2.lineHeight,
              }}
            />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default NoQuotaBanner;
